<mat-divider></mat-divider>
<footer>
  &copy; All rights reserved {{year}}
</footer>
